module.exports = __webpack_public_path__ + "bh.no2.f075edc8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/bh.no2.jpg
// module id = ek1X
// module chunks = 0